/**
 * ENVIRONMENT: PRODUCTION
 * MODULE: Prepaid Card Request Handlers
 * PATH: src/requests/prepaid.js
 */

import api from "utils/api";

export const getPrepaidCardsList = (query) => {
  // Remove the leading '/admin' so it doesn't double-prefix with axios baseURL
  return api.get("prepaid-cards-list", { params: query });
};